import { DialogTitle } from '@headlessui/react';
import { Modal } from '@retainerclub/common';
import PropTypes from 'prop-types';

function ManageShipmentModal({
  open,
  handleCloseModal,
  activeShipment = null,
  refetch,
}) {
  return activeShipment ? (
    <Modal open={open} setOpen={handleCloseModal} size="2xl">
      <div>
        <div className="text-center">
          <DialogTitle
            as="h2"
            className="font-semibold text-2xl text-rcgray-900 capitalize leading-6"
          >
            Update Shipment
          </DialogTitle>
        </div>
      </div>
    </Modal>
  ) : null;
}

ManageShipmentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  activeShipment: PropTypes.object,
  refetch: PropTypes.func.isRequired,
};

export default ManageShipmentModal;
